import { TimeDayPair } from '@data/course/courseData';
import React from 'react';

interface MeetingDisplayProps {
  meeting: TimeDayPair;
}

const MeetingDisplay: React.FC<MeetingDisplayProps> = ({ meeting }) => {
  return (
    <>
      <strong>
        {meeting.day} at {meeting.time}
      </strong>{' '}
      Local Time
    </>
  );
};

export default MeetingDisplay;
